// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MjxY9","type":"styles_type__2uU6G","choices":"styles_choices__3oXpc"};